import { render, staticRenderFns } from "./BenefitAddTeamManagerModal.vue?vue&type=template&id=5ccb2613&scoped=true&"
import script from "./BenefitAddTeamManagerModal.vue?vue&type=script&lang=ts&"
export * from "./BenefitAddTeamManagerModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccb2613",
  null
  
)

export default component.exports